
import slidersInit from "../components/sliders.js";
import tooltipsInit from "../components/tooltips.js";
import productInit from "../components/product.js";
// import lightboxInit from "../components/lightbox.js";
import lightGalleryInit from "../components/lightgallery.js";

document.addEventListener("DOMContentLoaded", () => {

    // init Tooltips
    tooltipsInit();

    // init Product Add to Shopping Cart
    const { addProductToShoppingCartHandle } = productInit();
    addProductToShoppingCartHandle();

    // init Product Slider
    const { productSliderInit, productInteriorSliderInit } = slidersInit();
    const sliderProduct = productSliderInit();
    productInteriorSliderInit();

    // init lightbox
    // const { lightboxWithButtonsInit } = lightboxInit();
    // lightboxWithButtonsInit('.product__item_slide', sliderProduct, '.product__slider');

    // init lightGallery
    const { lightGalleryWithButtonsInit } = lightGalleryInit();
    lightGalleryWithButtonsInit();


});
